// Import Swiper React components
import { useCallback, useRef } from 'react';

// Import Swiper styles
import 'swiper/css';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const VideoCarousel = () => {
	const sliderRef = useRef(null);

	const videos = [
		'https://www.youtube.com/embed/J22-U7aVjiY?si=OTWfALZmC7GKGpXm',
		'https://www.youtube.com/embed/vm2aJI2vK_Q?si=OTWfALZmC7GKGpXm',
		'https://www.youtube.com/embed/rFRWBMUXXuc?si=4hSP3xDzL9XTAgsb',
		'https://www.youtube.com/embed/KiykplX5Qvc?si=5h4A2ua4Jq1kGduJ',
		'https://www.youtube.com/embed/XILra4j-KsU?si=zRoYazehtGhXNeCz',
	];

	const handlePrev = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slidePrev();
	}, []);

	const handleNext = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slideNext();
	}, []);

	return (
		<>
			<section className="mx-auto mt-10 flex flex-col flex-wrap items-center justify-center" id="reviews">
				<div className="mx-auto mt-16 flex w-full max-w-7xl flex-col justify-center gap-6 px-4 md:pb-6">
					<div className="flex flex-row flex-wrap items-center justify-center">
						<div>
							<div className="flex flex-wrap items-center justify-center gap-1 text-sm font-light text-white lg:gap-3 lg:text-lg">
								<div className="flex lg:hidden">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
								</div>
								<div>
									<span className="hidden lg:inline-flex">Rated</span> "Excellent"{' '}
									<span className="font-bold">4.8/5</span>
								</div>
								<div className="hidden flex-row lg:flex">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
										className="h-4 w-4 text-[#FFA132] lg:h-5 lg:w-5">
										<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
									</svg>
								</div>
								by our <span className="font-bold">1000+</span> successful dropshippers
							</div>
							<div className="mb-4 mt-2 text-center text-white">
								Discover Why PagePilot is the Preferred Choice for Dropshippers.
							</div>
						</div>
					</div>
					<h2 className="text-transparent mx-auto bg-clip-text text-center text-3xl font-extrabold lg:text-5xl lg:leading-[60px]">
						<span className="text-transparent bg-gradient-to-b from-white from-40% to-[#b2b2b2] bg-clip-text">
							Used by{' '}
						</span>
						<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#5e53ff] bg-clip-text">
							3500+{' '}
						</span>
						<span className="text-transparent bg-gradient-to-b from-white from-40% to-[#b2b2b2] bg-clip-text">
							dropshippers everyday
						</span>
					</h2>

					<div className="mx-auto max-w-[350px] text-center text-lg text-white md:max-w-full lg:text-xl">
						Don't just take our word for it - see real reviews from our community members
					</div>
				</div>

				<div className="mx-auto w-full max-w-6xl text-white">
					<div className="relative w-full px-6">
						<div
							className="prev-arrow absolute left-[8px] top-1/2 z-20 flex h-14 w-14 items-center justify-center rounded-full bg-slate-800 hover:cursor-pointer"
							onClick={handlePrev}>
							<svg className="h-7 w-7 rotate-180 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
								<path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
							</svg>
						</div>
						<div
							className="next-arrow absolute right-[8px] top-1/2 z-20 flex h-14 w-14 items-center justify-center rounded-full bg-slate-800 hover:cursor-pointer"
							onClick={handleNext}>
							<svg className="h-7 w-7 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
								<path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
							</svg>
						</div>

						<Swiper
							className="mx-auto w-full max-w-4xl"
							modules={[Navigation, Pagination, Scrollbar, A11y]}
							ref={sliderRef}
							slidesPerView={1}
							navigation
							// pagination={{
							//   el: '#containerForBullets',
							//   type: 'bullets',
							//   bulletClass: 'swiper-custom-bullet',
							//   bulletActiveClass: 'swiper-custom-bullet-active',
							//   clickable: true,
							// }}
							scrollbar={{ draggable: true }}
							onSwiper={swiper => console.log(swiper)}
							onSlideChange={() => console.log('slide change')}>
							{videos.map((video, index) => (
								<SwiperSlide key={index} className="mt-10 w-full">
									<div className="w-full">
										<iframe
											className="relative z-20 min-h-[550px] w-full rounded-[30px]"
											src={video}
											title="YouTube video player"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>

				<div className="mx-auto mt-6 flex w-full max-w-[600px] flex-col items-center justify-center rounded-2xl md:mt-10 lg:gap-2">
					<div className="flex pb-2 pt-2 lg:pb-0 lg:pt-0">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							className="h-5 w-5 text-[#FFA132]">
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							className="h-5 w-5 text-[#FFA132]">
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							className="h-5 w-5 text-[#FFA132]">
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							className="h-5 w-5 text-[#FFA132]">
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
							fill="currentColor"
							className="h-5 w-5 text-[#FFA132]">
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
						</svg>
					</div>
					<p className="max-w-lg pb-2 text-center text-base/7 text-white lg:pb-0">
						"The experience has been fantastic up to this point. Creating Shopify product pages and Facebook ad
						creatives was seamless and efficient. Cant wait for he next update!"
					</p>
					<p className="text-center text-base text-gray-DEFAULT-400">Maria B.</p>
				</div>

				<div className="mx-auto mt-10 block w-full max-w-[2000px]">
					<div className="carousel-container carousel-fade overflow-hidden">
						<div className="carousel space-x-5">
							{Array.from({ length: 10 }, (_, i) => i + 1).map(number => (
								<div
									key={number}
									className="group flex w-[450px] cursor-pointer flex-col items-start rounded-2xl p-4 text-start transition duration-300 ease-out hover:cursor-pointer hover:border-[#5A5A5A]/40 hover:bg-white/5 md:w-[450px]">
									<div className="text-start text-sm font-light tracking-wide text-white/70 transition duration-300 ease-out group-hover:text-white lg:text-base">
										<img
											className="w-full rounded-3xl"
											src={`/images/landingpage/testimonials/${number}.webp`}
											alt="PagePilot.ai Review"
											width="418"
											height="300"
										/>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default VideoCarousel;
